/**
 * JavaScript obsluhující objednávkový fromulár
 */

window.addEventListener('load', () => {
    if(document.getElementById('frm-orderForm')) {
        const
            shipping = ID.shipping.value,
            payment = ID.payment.value;

        if (!_.isEmpty(shipping) && !_.isEmpty(payment)) {
            shippingPrice(document.location.pathname + '?do=shippingPrice');

        }

        // nastavení doprav a pleteb podle zeme
        const
            billingCountry = document.getElementById('frm-orderForm-billingCountry').value,
            deliveryCountry = document.getElementById('frm-orderForm-deliveryCountry').value,
            country = deliveryCountry !== '' ? deliveryCountry : billingCountry;

        setShippingPayment(country)

    }

})

const changeCountrySelect = document.getElementsByClassName('change-country');

Array.from(changeCountrySelect).forEach((element => {
    element.addEventListener('change', (e) => {
        const actualCountryCode = e.target.value;

        setShippingPayment(actualCountryCode, true)

        document.querySelectorAll('input[name="shippingRadio"]').forEach(el => {
            el.checked = false;
            el.disabled = false;
        });

        document.querySelectorAll('input[name="paymentRadio"]').forEach(el => {
            el.checked = false;
            el.disabled = false;
        });

        ID['payment'].value = '';
        ID['shipping'].value = '';

    })
}))

document.querySelectorAll('[type=radio][data-type]').forEach(element => {
    element.addEventListener('click', e => {
        let input = e.target;
        if (input.dataset.type === 'shipping') {
            ID.shipping.dataset.parent = input.dataset.parent;
    }
    });

    element.addEventListener('change', e => {
        let input = e.target;
        ID[input.dataset.type].value = input.value;

           if (input.dataset.type === 'shipping') {
                let sb = ID["selected-branch-" + input.dataset.parent];
                if(sb) sb.value = "";
                ID.payment.value = "";
                ID["shipping-branch"].value = "";
                FN.checkRadioValue(ID["frm-orderForm"], "shippingRadio", ID.shipping.value);
                FN.checkRadioValue(ID["frm-orderForm"], "paymentRadio", ID.payment.value);

                FN.uncheckInput('.payment-item input');
                document.querySelectorAll('[type=radio][data-type]').forEach(item =>
                    item==input ? item.parentNode.classList.add("active") : item.parentNode.classList.remove("active")
                );
            }

        if (input.dataset.link) shippingPrice(input.dataset.link);
    })
})

naja.addEventListener('success', () => {
    const deliveryAddressBtn = document.getElementsByClassName('set-delivery-address');
    Array.from(deliveryAddressBtn).forEach(element => {
        element.addEventListener('click', e => {
            const
                link = e.target.dataset.link,
                addressId = e.target.dataset.addressId

            naja.makeRequest('POST', link, {
                addressId: addressId
            }, {
                history: false
            }).then(r => {
                setShippingPayment(r.deliveryAddress.country, true)
                Object.entries({
                    addressee: "addressee",
                    deliveryCountry: "country",
                    deliveryStreet: "street",
                    deliveryCity: "city",
                    deliveryZip: "zip"
                }).forEach(([k,v]) => {
                    let obj = document.getElementById("frm-orderForm-"+k);
                    obj.value = r.deliveryAddress[v];
                    obj.setAttribute("readonly","");
                });
                document.getElementById('delivery-customer-code').value = r.deliveryAddress.customerCode
            })
        })
    });
})


const setShippingPayment = (countryCode) => {

    const
        shippingItemsByCountry = document.querySelectorAll('div[shipping-country="' + countryCode + '"]'),
        shippingItems = document.getElementsByClassName('shipping-item'),
        alertElement = document.getElementsByClassName('shipping-alert');

    Array.from(shippingItems).forEach(item => {
        item.classList.add('d-none');
    })

    Array.from(shippingItemsByCountry).forEach(item => {
        item.classList.remove('d-none');
    })

    Array.from(alertElement).forEach(element => {
        if(!countryCode) {
            element.classList.remove('d-none');

        } else {
            element.classList.add('d-none');

        }
    })

    FN.uncheckInput('[data-type]');
    FN.checkRadioValue(ID["frm-orderForm"], "shippingRadio", ID.shipping.value);
    FN.checkRadioValue(ID["frm-orderForm"], "paymentRadio", ID.payment.value);
    document.querySelectorAll('[type=radio][data-type]').forEach(item =>
        item.checked ? item.parentNode.classList.add("active") : item.parentNode.classList.remove("active")
    );

}


const shippingPrice = (link) => {
    naja.makeRequest('POST', link, {
        shipping: ID.shipping.value,
        payment: ID.payment.value,
        branchId: ID['shipping-branch'].value,
        parentId: ID.shipping.dataset.parent
    }, {
        history: false
    }).then(r => {

        if (r.branchData && ID.shipping.dataset.parent) {
            let selected = ID['selected-branch-' + ID.shipping.dataset.parent];
            if(selected) {
                selected.classList.remove('d-none');
                selected.querySelector(".title").innerHTML = r.branchData.address;
            }
            let input = ID["selected-shipping-" + ID.shipping.dataset.parent];
            input.checked = true;
        }

        const allowPayments = r.payments;
        if (!_.isUndefined(allowPayments)) {
            const payments = document.querySelectorAll('.payments-wrapp input[type="radio"]');

            payments.forEach(element => {
                if (element.hasAttribute('disabled')) {
                    element.removeAttribute('disabled');
                }
                if (allowPayments.includes && !allowPayments.includes(element.value)) {
                    element.setAttribute('disabled', 'disabled');
                }

                if (r.poorExcuses[element.value]) {
                    element.nextElementSibling.querySelector(".payment-excuse").innerHTML = r.poorExcuses[element.value];
                }
            });

        }
    })
}

window.addEventListener('load', () => {
    const form = document.querySelector('form[id*="saveOrderForm"]');
    const overlay = document.getElementById('order-submit-overlay');
    const message = document.getElementById('order-submit-message');
    const homeLink = document.getElementById('order-submit-home-link');

    if (!form || !overlay || !message || !homeLink) return;

    form.addEventListener('submit', () => {
        overlay.classList.remove('d-none');
        overlay.setAttribute('aria-busy', 'true');
        form.querySelectorAll('button, input[type="submit"]').forEach(control => {
            control.disabled = true;
        });

        const messages = [
            message.textContent,
            message.dataset.emailMessage,
            message.dataset.finishMessage
        ];
        let index = 0;
        setInterval(() => {
            index = (index + 1) % messages.length;
            message.textContent = messages[index];
        }, 1500);

        setTimeout(() => {
            homeLink.classList.remove('d-none');
        }, 70000);
    });
});
